import { createFileRoute } from '@tanstack/react-router';
import AuthGuard from '@/components/auth-guard';
import { PublishEditorContent } from '@/features/chapters/components/publish-editor-content';

export const Route = createFileRoute('/publish-editor/$chapterId')({
  component: PublishEditorPage,
});

function PublishEditorPage() {
  const { chapterId } = Route.useParams();

  return (
    <AuthGuard>
      <PublishEditorContent chapterId={chapterId} />
    </AuthGuard>
  );
}
